export default __webpack_public_path__ + "static/media/Tesca Textiles and Seal Components (India) Private Limited.390955c9.jpg";